<template>
  <div>
    <encabezado-filtros
      titulo="Miembros"
      :subtitulo="`${miembros.length} miembros registrados`"
      v-model:busqueda="busqueda"
      placeholder-busqueda="Buscar por nombre, RUT o matrícula"
    >
      <template v-slot:acciones>
        <v-btn color="primary" to="/nuevo-miembro">
          <v-icon start>mdi-plus</v-icon>
          Nuevo miembro
        </v-btn>
      </template>
    </encabezado-filtros>

    <v-card variant="outlined" rounded="lg">
      <v-data-table
        :loading="cargando"
        :headers="encabezadoTabla"
        :search="busqueda"
        :items="miembros"
        item-key="matricula"
        show-expand
        :footer-props="{ itemsPerPageText: 'Por página' }"
      >
      <template v-slot:[`item.nombre`]="{ item }">
        <div class="d-flex align-center py-1" style="gap: 12px">
          <v-avatar size="38">
            <v-img v-if="item.imagen" :src="urlImagen(item.imagen)" alt="Foto"></v-img>
            <v-icon v-else>mdi-account</v-icon>
          </v-avatar>
          <div>
            <div class="font-weight-medium">{{ item.nombre }}</div>
            <div class="text-caption text-muted">Matrícula {{ item.matricula }}</div>
          </div>
        </div>
      </template>

      <template v-slot:item.fechaInicio="{ item }">
        {{ formatoFecha(item.fechaInicio) }}
      </template>

    <template v-slot:item.fechaFin="{ item }">
      {{ formatoFecha(item.fechaFin) }}
    </template>

      <template v-slot:[`item.estado`]="{ item }">
        <v-chip
          variant="tonal"
          :color="estado(item.estado)"
          size="small"
          class="font-weight-medium"
        >
          {{ item.estado }}
          <span v-if="!item.estado">SIN MEMBRESÍA</span>
        </v-chip>
      </template>

      <template v-slot:[`item.opciones`]="{ item }">
        <v-tooltip location="bottom" color="primary">
          <template v-slot:activator="{ props }">
            <v-btn
              icon="mdi-pencil"
              color="primary"
              size="small"
              variant="text"
              v-bind="props"
              @click="editar(item.id)"
            >
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>

        <v-tooltip location="bottom" color="error">
          <template v-slot:activator="{ props }">
            <v-btn
              icon="mdi-delete"
              color="error"
              size="small"
              variant="text"
              v-bind="props"
              @click="eliminar(item)"
            >
            </v-btn>
          </template>
          <span>Eliminar</span>
        </v-tooltip>

        <!-- <v-tooltip location="bottom" color="secondary">
          <template v-slot:activator="{ props }">
            <v-btn icon="mdi-card-account-details" color="secondary" size="small" v-bind="props" @click="generarCredencial(item)">
            </v-btn>
          </template>
          <span>Generar credencial</span>
        </v-tooltip> -->

        <v-tooltip location="bottom" color="success">
          <template v-slot:activator="{ props }">
            <v-btn
              icon="mdi-wallet-membership"
              color="success"
              size="small"
              variant="text"
              v-bind="props"
              @click="realizarPago(item.matricula)"
            >
            </v-btn>
          </template>
          <span>Renovar Membresía</span>
        </v-tooltip>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          Más información de <b>{{ item.nombre }}</b>
          <v-table height="200px">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>
                    <v-icon color="indigo"> mdi-map-marker </v-icon>
                    <b>Dirección: </b>{{ item.direccion }} </td>
                </tr>
                <tr>
                  <td>
                    <v-icon color="indigo"> mdi-calendar </v-icon>
                    <b>Miembro desde: </b>{{ item.fechaRegistro }} </td>
                </tr>
                <tr>
                  <td>
                    <v-icon color="indigo"> mdi-calendar-account </v-icon>
                    <b>Edad: </b>{{ item.edad }} </td>
                </tr>
                <tr>
                  <td>
                      <v-icon color="indigo"> mdi-account </v-icon>
                    <b>En accidente comunicarse con: </b>{{ item.nombreContacto }}, <b>Teléfono:</b> {{ item.telefonoContacto }}</td>
                </tr>
                <tr>
                  <td>
                    <v-icon color="indigo"> mdi-mother-heart </v-icon>
                    <b>Enfermedades crónicas: </b>{{ item.enfermedad }} </td>
                </tr>
                <tr>
                  <td>
                    <v-icon color="indigo"> mdi-hospital-building </v-icon>
                    <b>Seguro en : </b>{{ item.institucion }} </td>
                </tr>
              </tbody>
            </template>
          </v-table>
        </td>
      </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="mostrarRealizarPago" persistent max-width="600">
      <realizar-pago
        :matricula="matriculaSeleccionada"
        @cerrar="cerrarDialogoPago"
        @pagado="onPagado"
      />
    </v-dialog>

    <v-dialog v-model="mostrarDialogoEliminar" max-width="500px">
      <dialogo-eliminar
        :nombre="itemSeleccionado"
        @cancelar="cerrarDialogoEliminar"
        @eliminar="confirmarEliminar"
      />
    </v-dialog>

  <credencial-miembro :matricula="matriculaSeleccionada" :miembro="miembro"  @impreso="onImpreso" v-if="mostrarCredencial"/>

    <v-snackbar
      v-model="mostrarMensaje"
      :timeout="3000"
      :color="mensaje.color"
      location="top"
    >
      {{ mensaje.texto }}
    </v-snackbar>

    <v-overlay :model-value="cargando">
      <v-progress-circular size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import HttpService from "../../Servicios/HttpService";
import Utiles from "../../Servicios/Utiles";
import RealizarPago from "./RealizarPago.vue";
import DialogoEliminar from "../Dialogos/DialogoEliminar.vue";
import CredencialMiembro from "./CredencialMiembro.vue"
import EncabezadoFiltros from "../Dialogos/EncabezadoFiltros.vue"

export default {
  name: "Miembros",
  components: { RealizarPago, DialogoEliminar, CredencialMiembro, EncabezadoFiltros },

  data: () => ({
    busqueda: "",
    encabezadoTabla: [
      {
        title: "Miembro",
        align: "start",
        sortable: true,
        key: "nombre",
      },
      {
        title: "RUT",
        sortable: false,
        key: "telefono",
      },
      {
        title: "Estado",
        sortable: true,
        key: "estado",
      },
      {
        title: "Inicio membresía",
        sortable: true,
        key: "fechaInicio",
      },
      {
        title: "Fin membresía",
        sortable: true,
        key: "fechaFin",
      },
      {
        title: "Membresía",
        sortable: true,
        key: "membresia",
      },
      { title: "Opciones", key: "opciones", sortable: false },
    ],
    cargando: false,
    mostrarMensaje: false,
    mensaje: {
      color: "",
      texto: "",
    },
    miembros: [],
    matriculaSeleccionada: "",
    mostrarRealizarPago: false,
    itemSeleccionado: null,
    miembro: null,
    mostrarDialogoEliminar: false,
    mostrarCredencial: false
  }),

  mounted() {
    this.obtenerMiembros();
  },

  methods: {
    formatoFecha(fecha) {
    if (!fecha) return '';
    const date = new Date(fecha);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    return `${day}-${month}-${year}`.replace(/\b(\d)\b/g, '0$1'); // Añade ceros si es necesario
  },
    generarCredencial(miembro){
      this.matriculaSeleccionada = miembro.matricula
      this.miembro = miembro
      this.mostrarCredencial = true
    },

    onImpreso(resultado) {
      this.mostrarCredencial = resultado;
    },

    eliminar(miembro) {
      this.itemSeleccionado = miembro.nombre;
      this.miembro = miembro;
      this.mostrarDialogoEliminar = true;
    },

    cerrarDialogoEliminar() {
      this.mostrarDialogoEliminar = false;
      this.miembro = null;
    },

    confirmarEliminar() {
      this.cargando = true;
      let payload = {
        metodo: "eliminar",
        id: this.miembro.id,
      };
      HttpService.eliminar("miembros.php", payload).then((eliminado) => {
        if (eliminado) {
          this.mostrarDialogoEliminar = false;
          this.mostrarMensaje = true;
          this.mensaje.texto = "Miembro eliminado";
          this.mensaje.color = "success";
          this.cargando = false;
          this.obtenerMiembros();
        }
      });
    },

    editar(idMiembro) {
      this.$router.push({
        name: "EditarMiembro",
        params: { id: idMiembro },
      });
    },

    urlImagen(imagen) {
      return Utiles.generarURL(imagen);
    },

    cerrarDialogoPago(resultado) {
      this.mostrarRealizarPago = resultado;
    },

    realizarPago(matricula) {
      this.matriculaSeleccionada = matricula;
      this.mostrarRealizarPago = true;
    },

    onPagado(resultado) {
      if (resultado) {
        this.mostrarRealizarPago = false;
        this.mostrarMensaje = true;
        this.mensaje = {
          color: "success",
          texto: "Pago realizado con éxito",
        };
        this.obtenerMiembros();
      }
    },

    obtenerMiembros() {
      this.cargando = true;
      const payload = { metodo: "get" };
      HttpService.obtenerConDatos(payload, "miembros.php").then((resultado) => {
        this.miembros = resultado;
        this.cargando = false;
      });
    },

    estado(val) {
      return val === "ACTIVO"
        ? "success"
        : val === "VENCIDO"
        ? "error"
        : "warning";
    },
  },
};
</script>
<style >
p {
  margin: 0;
}
</style>
